import React, { useState } from "react";
import {
  LayoutDashboard,
  BookOpenCheck,
  Users,
  Banknote,
  BarChart3,
  ShieldCheck,
  FlagTriangleRight,
  Bell,
  LineChart,
  Medal,
  Percent,
  CreditCard,
  FileText,
  ChevronLeft,
  ChevronRight,
  History,
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";

const sidebarItems = [
  { label: "Dashboard", icon: <LayoutDashboard size={28} />, path: "/admin" },
  {
    label: "Manage Courses",
    icon: <BookOpenCheck size={28} />,
    path: "/admin/courses",
  },
  { label: "Manage Users", icon: <Users size={28} />, path: "/admin/users" },
  {
    label: "Earnings",
    icon: <Banknote size={28} />,
    path: "/admin/earnings",
  },
  {
    label: "User Logs",
    icon: <History size={28} />,
    path: "/admin/user-logs",
  },
  { label: "Reports", icon: <BarChart3 size={28} />, path: "/admin/reports" },
  {
    label: "Security",
    icon: <ShieldCheck size={28} />,
    path: "/admin/security",
  },
  {
    label: "Reported Content",
    icon: <FlagTriangleRight size={28} />,
    path: "/admin/reports/content",
  },
  {
    label: "Send Notifications",
    icon: <Bell size={28} />,
    path: "/admin/notifications",
  },
  {
    label: "Course Performance",
    icon: <LineChart size={28} />,
    path: "/admin/performance/courses",
  },
  {
    label: "Instructor Performance",
    icon: <Medal size={28} />,
    path: "/admin/performance/instructors",
  },
  {
    label: "Create Coupons",
    icon: <Percent size={28} />,
    path: "/admin/coupons",
  },
  {
    label: "Payment Settings",
    icon: <CreditCard size={28} />,
    path: "/admin/payments",
  },
  {
    label: "Platform Reports",
    icon: <FileText size={28} />,
    path: "/admin/platform-reports",
  },
];

const AdminSidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  return (
    <div
      className={clsx(
        "bg-white border-r shadow-sm h-screen transition-all duration-300",
        collapsed ? "w-20" : "w-64"
      )}
    >
      <div className="flex items-center justify-between px-4 py-3 border-b">
        {!collapsed && (
          <h2 className="text-lg font-bold text-indigo-700">Admin Panel</h2>
        )}
        <button
          className="text-gray-500 hover:text-indigo-600"
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? <ChevronRight /> : <ChevronLeft />}
        </button>
      </div>

      <nav className="mt-4 space-y-2">
        {sidebarItems.map(({ label, icon, path }) => (
          <Link
            key={label}
            to={path}
            className={clsx(
              "flex items-center px-4 py-2 text-gray-700 hover:bg-indigo-100 transition rounded-md",
              location.pathname === path && "bg-indigo-100 text-indigo-700",
              collapsed ? "justify-center" : "gap-3"
            )}
          >
            <div className="min-w-[24px] text-indigo-600">{icon}</div>
            {!collapsed && <span className="text-sm font-medium">{label}</span>}
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default AdminSidebar;
